import { createRouter, createWebHistory } from 'vue-router';
import store from './store';

import BalanceSheetLayout from './components/BalanceSheetLayout.vue';
import Dashboard from './components/Dashboard.vue';
import Expenses from './components/Expenses.vue';
import Home from './components/Home.vue';
import Income from './components/Income.vue';
import Investments from './components/Investments.vue';
import SpreadsheetCopy from './components/SpreadsheetCopy.vue';
import SpreadsheetSelect from './components/SpreadsheetSelect.vue';

const routes = [
  {
    path: '/',
    component: Home,
  },
  {
    path: '/spreadsheets',
    component: SpreadsheetSelect,
  },
  {
    path: '/spreadsheets/copy',
    component: SpreadsheetCopy,
  },
  {
    path: '/spreadsheets/:id',
    component: BalanceSheetLayout,
    props: true,
    children: [
      {
        path: '',
        component: Dashboard,
      },
      {
        path: 'expenses',
        component: Expenses,
      },
      {
        path: 'investments',
        component: Investments,
      },
      {
        path: 'income',
        component: Income,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const isLoggedIn = store.state.auth.isLoggedIn;

  if (to.path != '/' && !isLoggedIn) {
    next('/');
  } else {
    next();
  }
});

export default router;
